import Vue from "vue";
import Router from "vue-router";
import StyleGuide from "@/view/StyleGuide.vue";
import { ROUTES } from "../config/routes.js";
import PageView from "@/view/PageView.vue";

Vue.use(Router);

export default new Router({
  mode: "hash",
  routes: [
    {
      path: ROUTES.app,
      name: "app",
      component: PageView,
    },
    {
      path: ROUTES.styleGuide,
      name: "style-guide",
      component: StyleGuide,
    },
  ],
});
